import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { TestModeService } from '../test-mode.service';

/**
 * HTTP Interceptor that detects the X-Test-Mode header sent by the backend
 * and updates the TestModeService accordingly.
 */
@Injectable()
export class TestModeInterceptor implements HttpInterceptor {
  private testModeService = inject(TestModeService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        const response = event as HttpResponse<any>;
        if (response?.headers?.has('X-Test-Mode')) {
          const isTestMode = response.headers.get('X-Test-Mode') === 'true';
          this.testModeService.setTestMode(isTestMode);
        } else {
          this.testModeService.setTestMode(false);
        }
      })
    );
  }
}
